const strings = {
  EDIT_USER: 'Ändra användare',
  EDIT_USER_INFORMATION:
    'Ändra informationen nedan för att skapa en ny användare.',
  APARTMENT_NUMBER: 'Lägenhetsnummer',
  EMAIL: 'Email',
  PASSWORD: 'Lösenord',
  JANITOR: 'Vaktmästare',
  ADMIN: 'Administratör',
  CANCEL: 'Avbryt',
  CREATE: 'Skapa',
  NOT_VALID_EMAIL: 'Emailadressen är inte giltlig',
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  USER_UPDATED: 'Användaren har uppdaterats',
  EMAIL_IN_USE: 'Emailadressen är redan i bruk',
  APARTMENT_IN_USE: 'Lägenhetsnumret är redan i bruk',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  INFO_CHANGE_PASSWORD: ''
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditUserModal/strings.js